import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Account } from '../../models/customer';
import { SinglePaymentReceiptRouteSettings } from '../../models/single-payment/single-payment-receipt-route-settings';
import { State } from '../../services/global-state';
import { ICustomerAccountToPay } from '../../services/hpf-transaction-service';

@autoinject
export class SinglePaymentReceipt {
	portalTemplateType;
	pnref;
	merchantKey;
	savedPaymentMethodToWallet;
	resultCode;
	resultMessage;
	planId;
	isFuturePayment;
	firstAccountCustomerAccountNumber;
	firstAccountBucketKey: number | null;
	accountPayments: ICustomerAccountToPay[];
	customMessage;

	constructor(
		private globalState: State,
		private router: Router
	) {
	}

	activate(params, routeConfig) {
		let paymentInformation: any;
		if (routeConfig.settings instanceof SinglePaymentReceiptRouteSettings) {
			let routeSettings: SinglePaymentReceiptRouteSettings = routeConfig.settings as SinglePaymentReceiptRouteSettings;
			this.accountPayments = routeSettings.accountPayments;
			paymentInformation = routeSettings.paymentInformation;
		}

		// get the accounts based on keys passed through route settings
		let accounts: Account[] = [];
		this.accountPayments.forEach((accountPayment: ICustomerAccountToPay) => {
			let selectedAccount: Account = this.globalState.accounts.find((accountFromState: Account) =>
				accountFromState.customerAccountKey === accountPayment.customerAccountKey
			);
			accounts.push(selectedAccount);
		});

		// arbitrarily pass first account to receipt component. It's used to look up merchant and for email audit.
		this.firstAccountCustomerAccountNumber = accounts[0].displayName;
		this.firstAccountBucketKey = accounts[0].bucket
			? accounts[0].bucket.bucketKey
			: accounts[0].bucketKey || null;

		this.portalTemplateType = paymentInformation.portalTemplateType;
		this.pnref = paymentInformation.pnref;
		this.merchantKey = paymentInformation.merchantKey;
		this.savedPaymentMethodToWallet = paymentInformation.savedPaymentMethodToWallet;
		this.resultCode = paymentInformation.resultCode;
		this.resultMessage = paymentInformation.resultMessage;
		this.planId = paymentInformation.planId || '';
		this.isFuturePayment = paymentInformation.isFuturePayment ? true : false;
		this.customMessage = paymentInformation.customMessage;
	}

	showError(error: string) {
		alert(error);
	}

	returnToDashboard() {
		this.router.navigateToRoute('secure');
	}
}
